import AccountsInstance from 'modules/accounts/repository';

export function savePassword(data) {
  return AccountsInstance.savePasswordUser(data);
}
